import React, { useState, useEffect } from 'react';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';

const MessagesList = ({ 
  messages, 
  user, 
  userReadStatus, 
  typingUsers,
  messagesEndRef,
  formatDate,
  shouldShowDateDivider,
  onAddReaction,
  onRemoveReaction
}) => {
  const [openPickerId, setOpenPickerId] = useState(null);

  // Ensure scroll to bottom when component mounts or messages change
  useEffect(() => {
    const messagesContainer = document.querySelector('.chat-messages');
    if (messagesContainer && messages.length > 0) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }, [messages]);
  // Find last message with read receipts
  const getLastMessageWithReaders = () => {
    for (let i = messages.length - 1; i >= 0; i--) {
      const message = messages[i];
      const readers = Object.values(userReadStatus).filter(
        status => status.lastReadMessageId === message.id && status.userId !== user?.uid
      );
      if (readers.length > 0) {
        return message.id;
      }
    }
    return null;
  };

  const lastMessageWithReaders = getLastMessageWithReaders();

  const handleTogglePicker = (messageId) => {
    setOpenPickerId(messageId);
  };

  return (
    <div className="messages-container">
      <div className="chat-messages">
        {messages.map((message, index) => {
          const isOwn = message.uid === user?.uid;
          const previousMessage = index > 0 ? messages[index - 1] : null;
          const nextMessage = index < messages.length - 1 ? messages[index + 1] : null;
          const showDateDivider = shouldShowDateDivider(message, previousMessage);
          
          // Show avatar only for last message in a series
          // Don't show avatar for optimistic messages if followed by real messages from same user
          const showAvatar = !isOwn && (!nextMessage || nextMessage.uid !== message.uid || 
            (message.isOptimistic && nextMessage && nextMessage.uid === message.uid && !nextMessage.isOptimistic));
          
          // Find users who read up to this message
          const usersWhoReadUpToHere = Object.values(userReadStatus).filter(
            status => status.lastReadMessageId === message.id && status.userId !== user?.uid
          );

          // Only show read receipts on the last message that has readers
          const isLastMessage = message.id === lastMessageWithReaders;

          return (
            <React.Fragment key={message.id}>
              {showDateDivider && (
                <div className="date-divider">
                  <span className="date-text">
                    {formatDate(message.timestamp)}
                  </span>
                </div>
              )}
              
              <MessageBubble
                message={message}
                isOwn={isOwn}
                showAvatar={showAvatar}
                usersWhoReadUpToHere={usersWhoReadUpToHere}
                isLastMessage={isLastMessage}
                onAddReaction={onAddReaction}
                onRemoveReaction={onRemoveReaction}
                openPickerId={openPickerId}
                onTogglePicker={handleTogglePicker}
                user={user}
              />
            </React.Fragment>
          );
        })}
        
        <div ref={messagesEndRef} />
      </div>
      
      <TypingIndicator typingUsers={typingUsers} />
    </div>
  );
};

export default MessagesList;